export default {
    Menu: 'Menu',
    Add: 'Adicionar',
    Modify: 'Editar',
    Delete: 'Eliminar',
    Scale: 'Redimensionar',
    Color: 'Cor',
    Materials: 'Materiais',
    Mesh: 'Malha',
    Size: 'Tamanho',
    Details: 'Detalhes',
    Quantity: 'Quantidade',
    AddToCart: 'Adicionar ao carrinho',
    AddToCartTitle: 'Adicionar ao carrinho',
    Cart: 'Carrinho',
    Total: 'Total',
    Subtotal: 'Subtotal',
    Shipping: 'Envio',
    Shape: 'Forma',
    PickShape: 'Escolha uma forma para adicionar à tela',
    ShapeAdded: 'Forma adicionada. Clique noutra para a substituir.',
    Clipart: 'Ilustração',
    PickClipart: 'Escolha uma ilustração para adicionar à tela',
    ClipartAdded: 'Ilustração adicionada. Clique noutra para a substituir.',
    SearchClipart: 'Procurar uma ilustração…',
    NoClipartFound: 'Nenhuma ilustração encontrada',
    Cliparts: 'Clipart',
    Illustration: 'Ilustração',
    AiImage: 'Imagem IA',
    AiImageIntro: 'Descreva o que pretende, escolha um formato e obtenha 2 propostas.',
    AiImageFormat: 'Formato',
    AiFormatSquare: 'Quadrado',
    AiFormatPortrait: 'Retrato',
    AiFormatLandscape: 'Paisagem',
    AiImagePlaceholder: 'Ex.: uma raposa ruiva estilizada, estilo plano, fundo transparente…',
    AiGenerate: 'Gerar',
    AiGenerating: 'A gerar…',
    AiPickResult: 'Escolha uma proposta',
    AiImageAdded: 'Imagem adicionada à tela',
    AiImageError: 'Falha ao gerar a imagem',
    AiNoResult: 'Nenhuma imagem gerada',
    AiImageNotInPlan: 'A geração de imagens IA não está incluída no seu plano. Ative a opção para a utilizar.',
    SearchIllustration: 'Procurar uma ilustração…',
    NoIllustrationFound: 'Nenhuma ilustração encontrada',
    IllustrationIntro: 'Procure ilustrações vetoriais para adicionar à tela.',
    IllustrationError: 'Falha na pesquisa de ilustrações',
    IllustrationNotVector: 'Este resultado não é um vetor utilizável',
    Texts: 'Textos',
    Images: 'Imagens',
    Colors: 'Cores',
    ThemeEditDesc: 'Edite os textos, imagens e cores do tema.',
    ThemeNotFound: 'Tema não encontrado.',
    ThemeNoEditable: 'Este tema não contém elementos editáveis.',
    Helpers: 'Réguas, guias e grelha',
    Rulers: 'Réguas',
    RulersHint: 'Escala em pixels',
    Guides: 'Guias',
    GuidesHint: 'Marcas a 25 / 50 / 75 %',
    GridHint: 'Grelha sobreposta',
    Snapping: 'Ajuste automático',
    SnappingHint: 'Alinha ao centro / grelha / outros objetos',
    LeaveConfirm: 'Tem a certeza de que quer perder as suas alterações?',
    Products: 'Produtos',
    Customization: 'Personalização',
    BackToCustomizationType: 'Tipo de personalização',
    SaveNoChanges: 'Nenhuma alteração para guardar',
    ChooseCategory: 'Escolha uma categoria',
    SelectProduct: 'Escolha um produto',
    Loading: 'A carregar',
    ProofLogoTooLarge: 'Logótipo demasiado grande (máximo 500 KB).',
    ProofLogoInvalidType: 'Formato de imagem não suportado.',
    ProofLogoImported: 'Logótipo importado.',
    ProofLogoImportFailed: 'Falha ao importar o logótipo.',
    YouHaveProjects: 'Tem {count} projeto(s) em curso',
    ResumeProject: 'Retomar um projeto',
    ResumeProjectHint: 'Continue de onde parou.',
    YourProjects: 'Os seus projetos em curso',
    OpenProject: 'Abrir este projeto',
    NoProjects: 'Nenhum projeto em curso.',
    AppUpdating: 'A atualizar a aplicação…',
    DraftRestored: 'Rascunho restaurado',
    SaveExpiredTitle: 'Gravação expirada',
    SaveExpiredMessage: 'Esta gravação expirou ou já não está disponível.',
    Continue: 'Continuar',
    PhotoFramePickShape: 'Escolha uma moldura',
    PhotoFramePlacePhoto: 'Coloque e ajuste a sua foto',
    PhotoFrameChangePhoto: 'Mudar de foto',
    PhotoFrameDropTitle: 'Arraste uma foto aqui',
    PhotoFrameDropSub: 'ou clique para carregar',
    Rotation: 'Rotação',
    Reset: 'Repor',
    ProofLogoTitle: 'Logótipo da prova',
    ProofLogoUseSite: 'Manter o logótipo de {site}',
    ProofLogoUseMine: 'Com o meu próprio logótipo',
    ProofLogoUseMineDesc: 'Apenas na prova, não nos ficheiros de impressão.',
    ProofLogoNone: 'Sem qualquer logótipo',
    ProofLogoDropTitle: 'Importe o seu logótipo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'A validar a sua encomenda',
    LoadingStepScreenshots: 'A gerar as pré-visualizações',
    LoadingStepPrintFile: 'A gerar os ficheiros de impressão',
    LoadingStepUpload: 'A enviar para o servidor',
    LoadingStepSave: 'A guardar a configuração',
    LoadingGraduation: 'A carregar a graduação',
    OptimizingImage: 'A otimizar a imagem',
    LoadingScene: 'A carregar a cena',
    LoadingStepZip: 'A criar o zip',
    LoadingProduct: 'A carregar o produto',
    Category: 'Categoria',
    Product: 'Produto',
    Summary: 'Resumo',
    Zone: 'Zona',
    SelectZone: 'Selecionar uma zona',
    SelectAZone: 'Escolher uma zona',
    Undo: 'Anular',
    Redo: 'Refazer',
    Recenter: 'Centrar a vista',
    HelpersIntro: 'Limites das zonas, grelha, réguas e guias na tela 2D.',
    ShowZoneBordersHint: 'Molduras das zonas na tela principal',
    Save: 'Guardar',
    Saving: 'A guardar',
    Grid: 'Grelha',
    SwitchTo3D: 'Mudar para 3D',
    PrintZone: 'Zona de impressão',
    ViewModeSwitch: 'Modo de visualização',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Duplo',
    ShowZoneBorders: 'Mostrar o contorno das zonas',
    ShowZoneBordersHelp: 'Mostra/oculta o contorno tracejado e a etiqueta das zonas na tela 2D.',
    ManageElements: 'Gerir os elementos',
    StartWithTheme: 'Começar com um tema',
    Customize: 'Personalizar',
    FromThemeLibrary: 'Da nossa biblioteca de temas',
    StartFromScratch: 'Começar do zero',
    Or: 'ou',
    PreviousCreations: 'Criações anteriores',
    WithModel: 'Com um modelo',
    Search: 'Procurar',
    SubCategory: 'Subcategoria',
    Next: 'Seguinte',
    Previous: 'Anterior',
    Validate: 'Validar',
    DownloadMyProject: 'Descarregar o meu projeto',
    EditThemeColors: 'Editar as cores dos elementos',
    AddPattern: 'Adicionar um fundo',
    EditGraduation: 'Editar o gradiente',
    Pattern: 'Fundo',
    PatternHint: 'O padrão é repetido em toda a área de personalização. As suas cores são personalizáveis.',
    SearchTheme: 'Procurar um tema (título ou etiqueta)',
    Theme: 'Tema',
    Graduation: 'Gradiente',
    Graduation_s: 'Gradiente(s)',
    ErrorOccurred: 'Ocorreu um erro.',
    ReloadPage: 'Recarregue a página.',
    LoadingCategories: 'A carregar as categorias',
    ShowAll: 'Ver tudo',
    Categories: 'Categorias',
    ComingSoon: 'Brevemente',
    DropImageHere: 'Arraste uma imagem para aqui',
    ReleaseToImport: 'Largue para importar',
    OrClickToBrowse: 'ou clique para procurar',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Este método de impressão funciona com cores definidas. Recomendamos ficheiros vetoriais para um resultado ótimo.',
    SearchInPhotoGallery: 'Procurar na nossa galeria de fotos',
    QrCode: 'Código QR',
    QrCodeContent: 'Conteúdo (URL, texto, e-mail…)',
    QrCodePlaceholder: 'https://exemplo.com',
    QrCodeForeground: 'Cor do QR',
    QrCodeBackground: 'Fundo',
    QrCodeTransparentBg: 'Fundo transparente',
    QrCodeErrorLevel: 'Tolerância a erros',
    QrCodeErrorL: '7 % (densidade baixa)',
    QrCodeErrorM: '15 % (padrão)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (alta)',
    QrCodeEmptyPreview: 'Introduza um conteúdo para pré-visualizar',
    QrCodeRequired: 'O conteúdo do código QR é obrigatório.',
    QrCodeInvalidUrl: 'Introduza um URL de código QR válido (http:// ou https://).',
    QrCodeAdd: 'Adicionar o código QR',
    QrCodeEditOnlyColors:
        'Após criar um código QR, só é possível alterar as cores. Para mudar o conteúdo, elimine-o e crie um novo.',
    ImageQualityGood: 'Boa resolução',
    ImageQualityMedium: 'Resolução média',
    ImageQualityLow: 'Baixa resolução – amplie a imagem ou reduza-a na tela',
    LowQualityAlertTitle: 'Atenção',
    LowQualityAlertMessage:
        'A sua criação contém imagens de baixa qualidade ou demasiado ampliadas em relação à resolução original. Corrija a criação ou aceite o risco de pixelização na impressão.',
    LowQualityAlertHint: 'Limite de baixa resolução:',
    LowQualityAcceptRisk: 'Aceito o risco de pixelização das minhas imagens de baixa qualidade',
    Preview: 'Pré-visualização',
    Bold: 'Negrito',
    Italic: 'Itálico',
    Underline: 'Sublinhado',
    FontSize: 'Tamanho',
    SelectFont: 'Escolher um tipo de letra',
    UploadFont: 'Carregar a minha fonte',
    UploadFontHint: 'TTF ou OTF · 5 MB máx.',
    CustomFontBadge: 'própria',
    CustomFontImported: 'Fonte importada.',
    CustomFontFormatError: 'Formato não suportado (apenas TTF ou OTF).',
    CustomFontTooLarge: 'Fonte demasiado grande (máximo 5 MB).',
    CustomFontImportFailed: 'Falha ao importar a fonte.',
    CustomFontRemoved: 'Fonte removida.',
    RecentFonts: 'Recentes',
    Clear: 'Limpar',
    TextColor: 'Cor do texto',
    TextOutline: 'Contorno',
    AddOutline: 'Adicionar um contorno',
    RemoveOutline: 'Remover o contorno',
    PickColor: 'Escolher uma cor',
    PickThemeCategory: 'Escolha uma categoria para explorar os temas',
    NoThemeInCategory: 'Nenhum tema nesta categoria',
    ThemePreviewLabel: 'Pré-visualização do tema',
    PickAnotherTheme: 'Escolher outro tema',
    Keep: 'Manter',
    LoadingThemes: 'A carregar os temas',
    LoadingPatterns: 'A carregar os fundos',
    EditableThemeColors: 'Cores editáveis dos elementos',
    PickAColor: 'Escolha uma cor',
    SelectALayout: 'Selecione um modelo',
    CreateLayer: 'Criar um elemento',
    LastDownloads: 'Últimas transferências',
    Cancel: 'Cancelar',
    Back: 'Voltar',
    BackToProvider: 'Voltar a {provider}',
    LayerNotFound: 'O elemento não foi encontrado',
    ChangeImage: 'Alterar a imagem',
    ChangePattern: 'Alterar o fundo',
    Resize: 'Redimensionar',
    RemoveBackground: 'Remover o fundo',
    Processing: 'A processar…',
    AddFilter: 'Adicionar um filtro',
    PhotoCredit: 'Foto de {author} em {provider}',
    PhotoBy: 'Foto de',
    On: 'em',
    LinkRedirectionWarning: 'Esta ligação irá redirecioná-lo para este site',
    LoadMore: 'Carregar mais',
    EditLayer: 'Editar o elemento',
    Import: 'Importar',
    FromYourDevice: 'Do seu dispositivo',
    FromImageGallery: 'Da galeria de imagens',
    NoGraduationsAvailable: 'Nenhum gradiente disponível',
    Confirm: 'Confirmar',
    CustomizeProduct: 'Personalize o seu produto',
    WriteYourText: 'Escreva o seu texto aqui',
    Text: 'Texto',
    Image: 'Imagem',
    DesignSummary: 'Resumo do seu design',
    AddOptions: 'Adicionar opções',
    TermsOfSale: 'Condições gerais de venda',
    TOSMessage:
        'Certifico que a minha criação está em conformidade com as [Condições gerais de venda](#) e, em particular, com o artigo 8 - Propriedade intelectual',
    IValidateMyCreation: 'Valido a minha criação',
    FunctionalityNotAvailable: 'Funcionalidade indisponível',
    Lock: 'Bloquear',
    Unlock: 'Desbloquear',
    AddLayer: 'Adicionar um elemento',
    LayerSectionTemplates: 'Modelos',
    LayerSectionText: 'Texto e dados',
    LayerSectionImages: 'Imagens',
    LayerSectionDecor: 'Decoração',
    LayerSectionTools: 'Ferramentas',
    DragLayersToReorder: 'Arraste as camadas para as reordenar',
    PleaseAgreeTOS: 'Aceite as condições gerais para validar a sua criação.',
    ErrorExportPrintFile: 'Ocorreu um erro ao exportar o ficheiro de impressão.',
    ErrorExportProofFile: 'Ocorreu um erro ao exportar a prova de impressão.',
    ErrorAddToCart: 'Ocorreu um erro ao adicionar ao carrinho: ',
    Gabarit: 'Molde',
    FicheTechnique: 'Ficha técnica',
    GeneratingPrintFile: 'A gerar o ficheiro de impressão…',
    GeneratingProofFile: 'A gerar a prova de impressão…',
    LeaveCustomizer: 'Sair do configurador',
    LeaveManager: 'Sair do gestor de elementos',
    ChangeProductTitle: 'A sua criação será apagada.',
    ChangeProductConfirm: 'Mudar de produto irá apagar a sua criação definitivamente, tem a certeza?',
    Duplicate: 'Duplicar',
    LoadingTheme: 'A carregar o tema',
    LoadingPattern: 'A carregar o fundo',
    Expand: 'Ampliar',
    Shrink: 'Reduzir',
    TiltLeft: 'Inclinar para a esquerda',
    TiltRight: 'Inclinar para a direita',
    Rotate: 'Rodar',
    Move: 'Mover',
    Reposition: 'Reposicionar',
    MoveUp: 'Mover para cima',
    MoveDown: 'Mover para baixo',
    MoveLeft: 'Mover para a esquerda',
    MoveRight: 'Mover para a direita',
    NoCustomization: 'Não há personalização no produto.',
    MissingCustomization: 'Personalização em falta',
    SelectGraduation: 'Selecione um gradiente',
    ProofTitle: 'Prova de impressão',
    ProofDesignTitle: 'Personalização 2D',
    ProofScreenshotsTitle: 'Vistas 3D',
    ProofSelectedInksTitle: 'Cores selecionadas',
    Warning: 'Atenção',
    SelectZoneBeforeTheme: 'Selecione uma zona antes de escolher um tema.',
    ThemeTooManyElements: 'O tema contém demasiados elementos. Escolha outro',
    Error: 'Erro',
    ProductNotFound: 'Produto não encontrado',
    ProductNotFoundMessage: 'Produto não encontrado, será redirecionado para a página inicial.',
    NoCategoryAvailable: 'Nenhuma categoria disponível',
    CategoryNotFound: 'Categoria não encontrada',
    CategoryNotFoundMessage: 'Categoria não encontrada, será redirecionado para a página inicial.',
    Unavailable: 'Indisponível',
    SavedConfigurations: 'Configurações guardadas',
    YourSavedConfigurations: 'As suas configurações guardadas',
    NoSavedConfigurations: 'Nenhuma configuração guardada para este produto',
    ConfigurationName: 'Nome da configuração',
    Created: 'Criado',
    Expires: 'Expira',
    Load: 'Carregar',
    ConfirmDeleteConfiguration: 'Tem a certeza de que quer eliminar esta configuração?',
    Close: 'Fechar',
    Step: 'Passo',
    CustomizeProductDesc: 'Escolha como começar: criação livre ou a partir de um tema proposto abaixo.',
    StartFromScratchDesc: 'Uma tela em branco para adicionar textos, imagens e formas, sem modelo imposto.',
    ChooseProductDesc: 'Escolha um produto para personalizar.',
    PrintMethod: 'Método de impressão',
    ChoosePrintMethod: 'Escolha o seu método',
    ChoosePrintMethodDesc:
        'Selecione o método de impressão para este produto. Esta escolha é definitiva para esta personalização.',
    Digital: 'Digital',
    ScreenPrinting: 'Serigrafia',
    LaserEngraving: 'Gravação a laser',
    Embroidery: 'Bordado',
    RestrictedToPalette: 'Cores limitadas à paleta',
    ChooseInks: 'Escolha as suas tintas',
    ChooseThreads: 'Escolha os seus fios',
    AppliesToZone: 'Zona: {zone}',
    Ink: 'Tinta',
    Thread: 'Fio',
    InkOverride: 'Forçar uma tinta',
    ThreadOverride: 'Forçar um fio',
    SuggestInks: 'Tintas sugeridas',
    SuggestThreads: 'Fios sugeridos',
    RecommendColorsFromImage: 'Recomendar cores a partir da imagem',
    NoColorSuggestion: 'Nenhuma sugestão de cor para esta imagem.',
    InkAssistantHelp: 'Este método utiliza uma paleta de {count} cores fixas.',
    InkAssistantQuestion: 'Como quer definir as suas cores?',
    InkAssistantUpload: 'Ajuda-me a encontrar as minhas cores',
    InkAssistantUploadDesc:
        'Importe a sua imagem, logótipo ou padrão – detetamos automaticamente as cores da paleta mais próximas.',
    InkAssistantManual: 'Escolho as minhas cores manualmente',
    InkAssistantManualDesc: 'Selecione cada cor, uma a uma, na paleta.',
    InkAssistantAnalyzing: 'A analisar a sua imagem…',
    InkChoiceModifiableHint: 'Esta escolha pode ser alterada a qualquer momento.',
    InkAssistantResultDesc: 'Aqui estão as cores da paleta mais próximas da sua imagem.',
    InkDuplicateWarning:
        'Esta cor já está selecionada para outra tinta / fio. Selecioná-la uma segunda vez irá fundir as cores definitivamente. Tem a certeza?',
    Selected: 'Selecionado',
    VectorizeImage: 'Vetorizar a imagem',
    Vectorizing: 'A vetorizar…',
    VectorizePreviewTitle: 'Resultado da vetorização',
    VectorizeIntro:
        'A imagem será convertida em vetor e limitada às tintas escolhidas. Valide o resultado para o aplicar.',
    VectorizeApply: 'Aplicar o vetor',
    VectorizeConsent:
        'Compreendo que sou responsável pelo controlo do resultado da vetorização e que a impressão será o reflexo desta.',
    VectorizeThreshold: 'Limite (detalhe / fundo)',
    VectorizeThresholdHint:
        'Ajuste o limite para afinar: mais baixo remove mais fundo claro (line-art); mais alto mantém mais zonas claras.',
    VectorizeCancel: 'Cancelar',
    VectorizeFailed: 'A vetorização falhou. Tente novamente ou mude de imagem.',
    Before: 'Antes',
    After: 'Depois',
    VariableText: 'Texto variável',
    VariableTextIntro:
        'Esta função assemelha-se a um mailing e permite obter o seu produto impresso num exemplar único por cada texto; a quantidade é calculada automaticamente para o seu carrinho.',
    VariableTextData: 'Dados (uma linha = um exemplar)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importar um CSV / Excel',
    SessionImages: 'Imagens importadas',
    Accept: 'Aceitar',
    UploadConsentMessage:
        'Confirmo que nenhum dos meus ficheiros viola as leis em vigor, os direitos de autor ou os direitos de terceiros.',
    VariableTextNoData: 'Adicione pelo menos uma linha para pré-visualizar.',
    VdpFields: 'Campos variáveis',
    VdpFieldName: 'Nome do campo',
    VdpPlace: 'Colocar',
    VdpPlaced: 'Colocado',
    VdpAddField: 'Adicionar um campo',
    VdpAddRow: 'Adicionar uma linha',
    VdpLine: 'Linha',
    VdpEnterData: 'Introduzir os meus dados',
    Done: 'Concluído',
    VdpFieldStyle: 'Estilo do campo',
    VdpFirstRowHeader: '1.ª linha = cabeçalho (nomes dos campos)',
    VdpQuantity: 'Quantidade: {qty}',
    VdpQuantityHint: 'A quantidade é imposta pelo número de linhas do seu texto variável.',
    VariableTextOnlyOne: 'Apenas um campo de texto variável por criação.',
    VariableTextEmptyFile: 'Ficheiro vazio ou sem coluna utilizável.',
    VariableTextImportError: 'Não é possível ler este ficheiro. Utilize um CSV ou cole o texto.',
    VariableTextExcelUnavailable: 'Leitura de Excel indisponível. Exporte para CSV ou cole o texto.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Tintas selecionadas: {chosen}/{required}. Escolha todas as tintas antes de validar.',
    PreflightScreenColorCount: 'Serigrafia: a sua criação está limitada a {count} tinta(s).',
    PreflightMinStroke: 'Espessura mínima de traço recomendada: {mm} mm. Traços mais finos podem imprimir mal.',
    PreflightMinFont: 'Tamanho mínimo de letra recomendado: {pt} pt.',
    PreflightLaserMonochrome: 'Gravação a laser: o resultado final será monocromático.',
    More: 'Mais',
    All: 'Todos',
    AllCategories: 'Todas as categorias',
    SearchCategory: 'Procurar uma categoria…',
    NoProductAvailable: 'Nenhum produto nesta categoria.',
    ChooseProductTitle: 'Escolhe o teu produto para personalizar',
    PrintMethodQuestion: 'Como queres imprimir o teu {product}?',
    PrintMethodIntro:
        'Cada método tem as suas vantagens e limitações — define as cores e acabamentos disponíveis a seguir.',
    StartLabel: 'Ponto de partida',
    StartTitle: 'Começa a partir de um tema ou de uma página em branco',
    StartIntro: 'Um tema = um design pronto a retocar (o mais rápido). Página em branco = controlo total.',
    StepProduct: 'Produto',
    StepMethod: 'Método',
    StepStart: 'Início',
    StepDesign: 'Design',
    ChangeTheme: 'Mudar de tema',
    BackToTheme: 'Voltar ao tema',
    Recent: 'Recentes',
    WhiteNotPrintable: 'O branco não pode ser impresso (transparente).',
    LoginToSave: 'Inicie sessão para encontrar as suas criações na sua conta.',
    Login: 'Iniciar sessão',
    LoggingIn: 'A iniciar sessão…',
    ContinueWithoutAccount: 'Continuar sem conta',
    SaveEmailPlaceholder: 'O seu endereço de e-mail',
    SaveEmailHint: 'Receberá um link para retomar o seu projeto (guardado 30 dias).',
    SaveConfirmTitle: 'Projeto guardado',
    SaveConfirmMessage: 'O seu projeto foi guardado. Acabámos de lhe enviar um e-mail com o link para o retomar.',
    DisableEmbroideryEffect: 'Desativar efeito de bordado',
    AddThread: 'Adicionar um fio',
    RemoveThread: 'Remover um fio',
    VectorizeDenoise: 'Reduzir o ruído',
    VectorizeDenoiseHint: 'Remove manchas e pequenos pontos indesejados.',
    VectorizeSmoothing: 'Suavização',
    VectorizeSmoothingHint: 'Arredonda os contornos (menos ângulos).',
    ZoomIn: 'Aumentar zoom',
    ZoomOut: 'Diminuir zoom',
    Fit: 'Ajustar',
    Apply: 'Aplicar',
    Edit: 'Editar',
    Support: 'Apoio',
    VectorizeAcknowledge:
        'Compreendo que sou responsável por verificar o resultado da vetorização e que a impressão irá refleti-lo.',
    Crop: 'Recortar',
    Font: 'Tipo de letra',
    Style: 'Estilo',
    Outline: 'Contorno',
    Steps: 'Passos',
    Tools: 'Ferramentas',
    ThemeColors: 'Cores',
    Minimize: 'Minimizar',
    MoveLayerUp: 'Mover camada para cima',
    MoveLayerDown: 'Mover camada para baixo',
    DragLayer: 'Arraste para reordenar',
    NoResult: 'Sem resultados',
    SearchElement: 'Pesquisar um elemento…',
    ExpertMode: 'Modo especialista',
    Finish: 'Concluir',
    ChooseImageOrPhoto: 'Escolher uma imagem ou fotografia',
    WizardIntro: 'Siga os passos para uma criação personalizada em 1 minuto.',
    WizardIntroExpert: 'Quer mais liberdade? Mude para o modo especialista.',
    ClickToChooseImage: 'Clique aqui para escolher uma imagem ou fotografia',
    ChooseCategoryDesc: 'Selecione uma família de produtos para começar.',
    SelectProductDesc: 'Selecione um produto para começar…',
    FinalReview: 'Último passo',
    StartWithThemeDesc: 'Comece a partir de um design pré-configurado.',
    WithModelDesc: 'Escolha um modelo pronto a usar.',
    ExpertModeConfirmTitle: 'Modo especialista',
    ExpertModeConfirmMsg:
        'Mudar para o modo especialista é uma escolha definitiva. Este modo é um pouco mais complexo de usar, mas permite adicionar e editar elementos sem restrições.',
    ExpertModeHint: 'Complete a sua criação sem limites: adicione textos e fotos como quiser.',
    VariableData: 'Dados variáveis',
    PhotoFrame: 'Moldura de fotografia',
    PhotoFrameHint: 'Escolha uma forma e depois coloque uma fotografia no interior.',
    PhotoFrameChooseShape: '1. Forma da moldura',
    PhotoFrameChangeShape: 'Mudar de forma',
    PhotoFramePickPhoto: 'Escolher uma fotografia',
    FromLibrary: 'Da biblioteca',
    VdpMaxRowsReached: 'Stock máximo atingido',
    VdpImportTruncated: 'Importação limitada ao stock disponível',
    LetterSpacing: 'Espaçamento entre letras',
    OutlineActive: 'Contorno ativado',
    OutlineThickness: 'Espessura do contorno',
    AlignLeft: 'Alinhar à esquerda',
    AlignCenter: 'Centralizar',
    AlignRight: 'Alinhar à direita',
    Uppercase: 'Maiúsculas',
    TextFormatting: 'Formatação',
    FontSizeLabel: 'Tamanho da fonte',
    SelectionActions: 'Ações da seleção',
    DragToMove: 'Arraste para mover',
    DragToResize: 'Arraste para redimensionar',
    DragToRotate: 'Arraste para girar',
    MoveUpOneLevel: 'Subir um nível',
    MoveDownOneLevel: 'Descer um nível',
    BringToFront: 'Trazer para a frente',
    Front: 'Primeiro plano',
    SendToBack: 'Enviar para trás',
    BackgroundNeverUnderPattern: 'Fundo (nunca sob um padrão de fundo)',
    EyedropperColor: 'Conta-gotas de cor',
    PresetColors: 'Cores predefinidas',
    RecentColors: 'Cores recentes',
    Palette: 'Paleta',
    HexValue: 'Valor hexadecimal',
    AiResultsHint: 'Encontre todas as sugestões no separador Imagem',
    Notifications: 'Notificações',
    Zoom: 'Zoom',
    GuidedCustomization: 'Personalização guiada',
    Actions: 'Ações',
    InkAssistantYourChoice: 'Escolheu:',
    InkAssistantCorrectQuestion: 'Deseja corrigir esta escolha?',
    ZonePrices: 'Preço por zona',
    ZonePriceApplied: 'Aplicado',
    ZonePriceUncovered: 'Nenhuma opção cobre todas as zonas decoradas.',
    ZonePricesShow: 'Mostrar',
    ZonePricesHide: 'Ocultar',
    '': ''
};
